import React, { useEffect } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import Copyright from '../Components/Copyright';

export default function PageLayout({ children, title }) {
  useEffect(() => {
    if (title) {
      document.title = `${title} - Rishta.Money`;
    }
  }, [title]);

  return (
    <div>
      <Navbar />
      <div className="pt-[100px] pb-10">
        {children}
      </div>
      <Footer />
      <Copyright />
    </div>
  );
}
